import React from 'react';
import StatesYearEvaluations from '@/features/dashboard-eval/components/states/StatesYearEvaluations';
import ParentLayout from './ParentLayout';

export default function Layout() {
  return (
    <ParentLayout title="Evaluations">
      {function(params) {
        return (
          <>
            <StatesYearEvaluations params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
